import React from 'react';
import { View } from 'react-native';
import FormTextInput from '../../../../components/FormTextInput';
import MainButton from '../../../../components/Buttons/MainButton';
import { MainColors } from '../../../../constants/Colors';
import ChoiceCardInput from './ChoiceCardInput';

const BallotItemForm = (props) => {
    return (
        <View>
            <FormTextInput
                label="Ballot Item Title"
                placeholder="Enter ballot item title"
                accessibilityLabel="Enter ballot item title"
                accessibilityHint="Type in a ballot item title here"
                value={props.titleValue}
                onChangeText={props.onChangeTitleText}
                editable={props.titleEditable}
            />

            <FormTextInput
                label="Ballot Item Description (optional)"
                placeholder="Enter ballot item description"
                accessibilityLabel="Enter ballot item description"
                accessibilityHint="Type in a ballot item description here"
                value={props.descriptionValue}
                onChangeText={props.onChangeDescriptionText}
                editable={props.descriptionEditable}
                multiline={true}
            />

            <ChoiceCardInput 
                choices={props.choices}
                onDeleteChoicePressed={props.onDeleteChoicePressed}
                choiceDeleteButtonDisabled={props.choiceDeleteButtonDisabled}
                choiceTitleValue={props.choiceTitleValue}
                onChangeChoiceTitle={props.onChangeChoiceTitle}
                choiceExplanationValue={props.choiceExplanationValue}
                onChangeChoiceExplanation={props.onChangeChoiceExplanation}
                onAddChoicePressed={props.onAddChoicePressed}
                choiceInputControlVisible={props.choiceInputControlVisible}
            />

            <MainButton
                text={props.formButtonText}
                accessibilityLabel={props.formButtonAccessibilityLabel}
                accessibilityHint={props.formButtonAccessibilityHint}
                disabled={props.formButtonDisabled}
                style={{ marginTop: 30, backgroundColor: props.formButtonDisabled ? MainColors.lightGray : MainColors.primary }}
                onPress={props.formButtonPressed}
            />
        </View>
    )
}

export default BallotItemForm;